import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { css } from "@emotion/css";
import { Controller, useFormContext } from "react-hook-form";
import TranslatedTextField from "./TranslatedTextField";
import MediaUploadField from "./MediaUploadField";
import ContentSection from "./ContentSection";
import QuestionsSection from "./QuestionsSection";
import { LessonFormData, emptyLocalizedText } from "../types";
import { useActiveLocale } from "../ActiveLocaleContext";

type Props = { partIndex: number };

const LessonPartCard: React.VFC<Props> = ({ partIndex }) => {
  const { control } = useFormContext<LessonFormData>();
  const { activeLocale } = useActiveLocale();

  // Note: part.id and part.translationIds are intentionally NOT registered.
  // RHF v6's register() skips applying the defaultValue for paths inside a
  // field array, which causes getValues() to merge `undefined` over the
  // shallow-state default and wipe these metadata fields. Leaving them
  // unregistered lets shallowFieldsStateRef carry them through unchanged.

  return (
    <Paper variant="outlined" className={styles.card}>
      <Typography variant="h5" gutterBottom>
        Part {partIndex + 1}
      </Typography>

      <Controller
        control={control}
        name={`parts.${partIndex}.title` as const}
        render={({ onChange, value }) => (
          <TranslatedTextField
            label="Part title"
            value={value ?? emptyLocalizedText()}
            onChange={onChange}
            activeLocale={activeLocale}
          />
        )}
      />

      <Controller
        control={control}
        name={`parts.${partIndex}.imageUrl` as const}
        render={({ onChange, value }) => (
          <MediaUploadField label="Cover image" value={value ?? emptyLocalizedText()} onChange={onChange} />
        )}
      />

      <ContentSection partIndex={partIndex} />
      <QuestionsSection partIndex={partIndex} />
    </Paper>
  );
};

export default LessonPartCard;

const styles = {
  card: css`
    padding: 16px;
    margin-bottom: 16px;
  `,
};
